import { Tooltip, mergeClasses } from '@fluentui/react-components';
import { WeatherSunny20Regular, WeatherMoon20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@theme';
import { useThemeToggleButtonStyles } from './ThemeToggleButton.styles';

export interface ThemeToggleButtonProps {
  className?: string;
}

export const ThemeToggleButton = ({ className }: ThemeToggleButtonProps) => {
  const styles = useThemeToggleButtonStyles();
  const { toggleTheme, isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <Tooltip content={t('header.themeToggle')} relationship="label">
      <button
        className={mergeClasses(styles.root, className)}
        onClick={toggleTheme}
        aria-label={t('header.themeToggle')}
        type="button"
      >
        {isDarkMode ? (
          <WeatherSunny20Regular className={styles.icon} />
        ) : (
          <WeatherMoon20Regular className={styles.icon} />
        )}
      </button>
    </Tooltip>
  );
};

ThemeToggleButton.displayName = 'ThemeToggleButton';
